export function transformPascalCase(pascalCasedString: string): string {
  // https://stackoverflow.com/questions/4149276/how-to-convert-camelcase-to-camel-case

  return (
    pascalCasedString
      // insert a space before all caps
      .replace(/([A-Z])/g, " $1")
      // uppercase the first character
      .replace(/^./, function (str) {
        return str.toUpperCase();
      })
  );
}
